'use strict';

import Headroom from 'headroom.js';
import { getMenuBreakpoint } from '../../utils/utils';
import {waitForDependencies} from "../_imports/utils/utils.common";
import {getHeaderHeight, setHeaderHeight, setMainNavHeight } from '../_imports/utils/utils.common';

let isSimpleNav;
let isSticky;

const heroSearch = document.querySelector('.hero-search');
let baseWidth = window.innerWidth;

const detectAiResearchPage = () => {
    const navAiresearchSimple = document.querySelector('.research-simplified-nav');
    const headerAiresearch = document.querySelector('.simple-ai-research');
    const subNavLogo = document.querySelector('.subnav-logo');
    const facadeDesktop = document.querySelector('.facade');
    const facadeMobile = document.querySelector('.facade-mobile');

    if(headerAiresearch || navAiresearchSimple) {
        if (facadeDesktop) {
            facadeDesktop.style.display = 'none';
        }

        if (facadeMobile) {
            facadeMobile.style.display= 'none';
        }

        if (navAiresearchSimple && subNavLogo) {
            subNavLogo.style.display = 'none';
        } 
    }
};

const detectSimpleNav = () => {
    const headerContent = document.querySelector('.header-content');
    const facadeDesktop = document.querySelector('.facade');
    const facadeMobile = document.querySelector('.facade-mobile');
    
    if(headerContent?.classList.contains('simple')) {
        facadeDesktop.style.display = 'none';
        facadeMobile.style.display= 'none';
        isSimpleNav = true;
    }
};

const moveSearchToHeroBanner = () => {
    const $dropdownTabSection = $('.coveo-dropdown-tab-section');
    const $heroSearch = $('.hero-search');

    if ($('.coveo-search-section').length) {
        const checkCoveoSearchTab = setInterval(() => {
            if ($dropdownTabSection.length) {
                let delay = 0;

                if ($dropdownTabSection[0].children.length) {
                    clearInterval(checkCoveoSearchTab);

                    if ($heroSearch.length) {
                        $('.coveo-search-section').parent().appendTo('.hero-search');
                        $heroSearch.css('min-height', $heroSearch.height());

                        delay = 500;
                    }

                    setTimeout(() => {
                        $('.search_container.coveodotcom').removeClass('navigation-header-cshtml');
                        $(".coveo-dropdown-searchbox-section").velocity({opacity: 1}, 100);
                    }, delay);
                }
            }
        }, 200);
    } else {
        $('.search_container.coveodotcom').removeAttr('style');
    }
};

const setMobileZone = () => {
    const body = document.querySelector('body');
    const header = document.querySelector('header');
    let resizeTimeout;

    if (isViewportMobile()) {
        appendMobileSearch();
        setMobileSearchTrigger();  
    } else {
        moveSearchInHeader();
    }
  
    $(window).on("resize", function () {
        clearTimeout(resizeTimeout);

        const newWidth = window.innerWidth;

        setHeaderHeight();
        setMainNavHeight();

        if(baseWidth !== newWidth) {
            resizeTimeout = setTimeout(() => {
           
                if (isViewportMobile()) {
                    appendMobileSearch();
    
                    if (!($('.facade-mobile').hasClass('event-set'))) {
                        setMobileSearchTrigger();
                    }
                } else {
                    body.classList.remove("noScroll");
                    
                    if (header.classList.contains('is-fixed')) {
                        moveSearchInMainNav();
                    } else {
                        moveSearchInHeader();
                    }
                }
                baseWidth = newWidth;
        }, 500);
    }
    });
};

/*
* Check if viewport size represent mobile view
 */
const isViewportMobile = () => {
    return breakpoint === 'xs' || breakpoint === 'sm' || getMenuBreakpoint() === 'tablet-ls';
};

/*
* Add sticky class to header
 */
const initHeadroomJS = (config = {}) => {
    const stickyElement = config.stickyElement || document.querySelector("header"),
        $headerContent = $('body > header .header_content'),
        $hamburgerd = $('.hamburgerd'),
        $heroSearch = $(".hero[am-hero~='search']"),
        $header = $('header'),
        $headerTop = $('div.header_top'),
        $subnavTrigger = '[data-submenu="trigger"]';

    let scrollY = 0;
    let offset = $('header').outerHeight(true) + 50;
    let isScrolling;

    /*
    * Change offset for page with small hero
     */
    if($('[data-page="cuse"]').length || $('#page-circle').length || $heroSearch.length) {
        offset = 250;
    }

    /*
    * Hide header on scroll
    * If you scroll down 10px, the header translate 10px up.
    * This is a workaround to mimic an absolute position. We need to do this, because the subnav is fixed.
     */
    
        $(window).on('scroll', function () {
            scrollY = window.scrollY;

            window.clearTimeout(isScrolling);

            if (!$header.hasClass('is-fixed')) {
               
                if ($header.hasClass('is-visible')) {
                    $header.removeClass('is-visible');
                }

                $header
                    .velocity('stop')
                    .css('transform', `translateY(-${window.scrollY}px)`);

                if(!isSimpleNav && !heroSearch) {
                    if( isViewportMobile()){
                        appendMobileSearch();
                        if(!($('.facade-mobile').hasClass('event-set'))){
                            setMobileSearchTrigger();
                        }
                    } 
                }
            }

            if(!isViewportMobile()) {
                isScrolling = setTimeout(() => {
                    if(window.scrollY <= 137) {
                        if($header.hasClass('is-fixed')) {
                            $header.removeClass('is-fixed');
                            $header.velocity({
                                translateY: 0
                            },
                            {
                                duration: 1200,
                                easing: [1000, 70]
                            });
                        }

                        if(!isSimpleNav && !heroSearch) {
                            moveSearchInHeader();
                        }
                    };
                }, 150);
            }

        });


    const headroom = new Headroom(stickyElement, {
        offset: offset,
        onTop: function () {
            isSticky = false;

            $hamburgerd.addClass('inactive').fadeOut(200, function () {
                $(this).removeClass('is-active');
            });

            $headerContent.removeAttr('style');

            if($header.hasClass('scrolling-to-section')) {
                $header.removeClass('scrolling-to-section');
            }

            if(!$header.hasClass('initial-state')) {
                if($(`${$subnavTrigger}`).hasClass('active')) {
                    $(`${$subnavTrigger}.active`).click();
                }

                const headerinterval = setInterval(() => {
                    if(scrollY === 0) {
                        clearInterval(headerinterval);
                       
                        setTimeout(() => {
                            if($header.css('opacity') === '0') {
                                $header.velocity({
                                    opacity: 1
                                },
                                {
                                    queue: false,
                                    duration: 250,
                                    easing: 'ease',
                                    begin: () => {
                                        $header.data('pin-transition', 'true');
                                    },
                                    complete: () => {
                                        $header.data('pin-transition', 'false');
                                    }
                                });
                            }
                        }, 500);
                    }
                }, 150);
            }

            $header.removeClass('initial-state');
        },
        onNotTop: function () {
            isSticky = true;

            $headerContent.removeClass("active");
            $hamburgerd.removeClass('inactive').fadeIn(200);

            if (!$('html').hasClass('hide-nav')) {

                const headerHeight = getHeaderHeight();
                
                let velocityTranslateYValue = -1 * headerHeight;
            
                if(document.documentElement.className.includes('push-banner-is-visible')) {
                    const pushBannerHeight = document.querySelector('[data-push-banner]')?.clientHeight;
                    const headerHeight = getHeaderHeight();

                    velocityTranslateYValue = -(headerHeight + pushBannerHeight);
                }

                $header.
                removeAttr('style')
                    .addClass('is-fixed')
                    .removeClass('is-visible')
                    .velocity({
                            translateY: [velocityTranslateYValue, -(scrollY)],
                            opacity: 1
                        },
                        {
                            queue: false,
                            duration: 420,
                            easing: 'ease-in-out',
                            begin: () => {
                                $header.data('pin-transition', 'true');
                            },
                            complete: () => {
                                $header.data('pin-transition', 'false');
                            }
                        });
            }
    
            if(!isViewportMobile() && !isSimpleNav &&!heroSearch) {
                moveSearchInMainNav();
            }
        }
    });

    headroom.init();
};

const moveSearchInMainNav = () => {
    const redirectUrl = emptyAtomicSearchInterfaceAndGetRedirectUrl();

    
    const header = document.querySelector('header');

    //add class search-in-sticky-nav to header 
    header.classList.remove('search-in-header');
    header.classList.add('search-in-sticky-nav', 'search-closed');
   
    $('header .search-box-container').append($('.search_container.coveodotcom').first());

    addAtomicSearchBoxToSearchInterfaceWithRedirectUrl(redirectUrl);

    document.dispatchEvent(new CustomEvent('main-nav-search-box-close'));
 };
 

const moveSearchInHeader = () => {
    const redirectUrl = emptyAtomicSearchInterfaceAndGetRedirectUrl();
    
    const header = document.querySelector('header');

    //reset headers classes
    header.classList.remove('search-in-sticky-nav', 'search-closed');
    header.classList.add('search-in-header');

    $('.search_container.coveodotcom').first().insertBefore($('.meta-navigation.list-inline'));

    addAtomicSearchBoxToSearchInterfaceWithRedirectUrl(redirectUrl);
};

const appendMobileSearch = () => {
    const redirectUrl = emptyAtomicSearchInterfaceAndGetRedirectUrl();

    const mobileSearchBar = document.querySelector('.mobile-search-bar');

    if (mobileSearchBar) {
        const search = document.querySelector('.search_container.coveodotcom');
        const header = document.querySelector('header');
    
        // reset headers classes
        header?.classList.remove('search-in-sticky-nav', 'search-open', 'search-closed');

        if (search) {
            mobileSearchBar.append(search);
        }

        addAtomicSearchBoxToSearchInterfaceWithRedirectUrl(redirectUrl);
    }
}

const getAtomicSearchInterface = () => {
    return document.querySelector('#search-box');
};

const emptyAtomicSearchInterfaceAndGetRedirectUrl = () => {
    const atomicSearchInterfaceForSearchBox = getAtomicSearchInterface();

    if (atomicSearchInterfaceForSearchBox) {
        const atomicSearchBox = atomicSearchInterfaceForSearchBox.querySelector('atomic-search-box');
       

        if (atomicSearchBox) {
            const redirectUrl = atomicSearchBox.getAttribute('redirection-url');
    
            atomicSearchInterfaceForSearchBox.innerHTML = '';
        
            return redirectUrl;
        }
    }
};

const addAtomicSearchBoxToSearchInterfaceWithRedirectUrl = redirectUrl => {
    const atomicSearchInterfaceForSearchBox = getAtomicSearchInterface();

    if (atomicSearchInterfaceForSearchBox) {
        setTimeout(() => {
            atomicSearchInterfaceForSearchBox.innerHTML = `<atomic-search-box redirection-url="${redirectUrl}"></atomic-search-box>`;
        }, 0);
    }
};

const setMobileSearchTrigger = () => {
    const headerContent = document.querySelector('.header-content');
    const body = document.querySelector('body');
    const facadeMobile = document.querySelector('.facade-mobile');
    const searchPanelContainer = document.querySelector('.search-panel-container');
    const hamburgerMenu = document.querySelector('#mobile-nav-trigger');
    const headerMobile = document.querySelector('.header-mobile');

    if (facadeMobile
        && searchPanelContainer
        && hamburgerMenu
        && headerMobile) {

        facadeMobile.addEventListener('click', () => {
            facadeMobile.classList.add('event-set');
            headerMobile.classList.toggle('search-mobile-open');
    
            //close or open mobile search panel depending on the nav state    
            if(searchPanelContainer.classList.contains('mobile-search-active') &&!hamburgerMenu.classList.contains('open')) {
                searchPanelContainer.classList.remove('mobile-search-active');
                headerContent.classList.remove('mobile-search-active');
    
                if(headerContent.classList.contains('active')) {
                    hamburgerMenu.classList.add('open')
                }
            } else {
                searchPanelContainer.classList.add('mobile-search-active');
                headerContent.classList.add('mobile-search-active');
                hamburgerMenu.classList.remove('open');
            }
        });
        
        hamburgerMenu.addEventListener('click', () => {
            if(headerContent.classList.contains('mobile-search-active')) {
                searchPanelContainer.classList.remove('mobile-search-active');
                headerContent.classList.remove('mobile-search-active');
    
                headerContent.classList.add('active'); 
                hamburgerMenu.classList.add('open');
                body.classList.add('noScroll');
    
                document.dispatchEvent(new CustomEvent('mobile-nav-open'));
                window.CoveoWebsite.queuedEvents = {
                    openMobileNav: true
                };
            } 
    
            //if the search panel is open when we click on hamburgermenu,
            // it closes it to hide X and show the search button
            if(headerMobile.classList.contains ('search-mobile-open')) {
                headerMobile.classList.remove('search-mobile-open');
            }
        });

    }
}


const setObserverOnSearchBar = () => {
    const targetNode = document.querySelector('.magic-box');
    const searchBox = document.querySelector('.CoveoSearchbox');
    const searchButton = document.querySelector('.CoveoSearchButton');
    const config = { attributes: true };

 //set an observer to detect when the magicbox element has the focus
 //class and add a a class to the searchbox accordingly
    const callback = (mutationsList, observer) => {
        for (let mutation of mutationsList) {    
            
            if (mutation.type === 'attributes' ) {
                if(mutation.target.classList.contains('magic-box-hasFocus')){
                    searchBox.classList.add('search-box-focus');
                } 
                else {
                    searchBox.classList.remove('search-box-focus')
                }
            }
        }
    };

    const observer = new MutationObserver(callback);

    if(targetNode) {
        observer.observe(targetNode, config);
    }
};

const menuInit = () => {
    detectAiResearchPage();
    detectSimpleNav();

    if(!heroSearch && !isSimpleNav) {
        setMobileZone();
    }

    setObserverOnSearchBar();

    if ( $("body[data-mode='normal']").length !== 0 ){
        initHeadroomJS();   
    }
};

waitForDependencies(() => {
    if($('header').length) {
        menuInit();
        moveSearchToHeroBanner();
    }
});